import { render, staticRenderFns } from "./DesktopSettings.vue?vue&type=template&id=651b00b6&scoped=true"
import script from "./DesktopSettings.vue?vue&type=script&lang=js"
export * from "./DesktopSettings.vue?vue&type=script&lang=js"
import style0 from "./DesktopSettings.vue?vue&type=style&index=0&id=651b00b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b00b6",
  null
  
)

export default component.exports